class CameraController {
    setPosition(x, y, z) {
        throw new Error("Method .setPosition is not implemented");
    }

    setTarget(x, y, z) {
        throw new Error("Method .setTarget is not implemented");
    }

    setFov(fov) {
        throw new Error("Method .setFov is not implemented");
    }

    setZoom(zoom) {
        throw new Error("Method .setZoom is not implemented");
    }

    setNear(near) {
        throw new Error("Method .setNear is not implemented");
    }

    setFar(far) {
        throw new Error("Method .setFar is not implemented");
    }
}

export default CameraController;
